import axios from 'axios';
const Vue = require('vue');
const _ = require('lodash');
export default {
    data() {
        return {
            isNew: null,
            league: null,
            user: null,
            ready: false,
            alwaysShowSave: false,
            finished: false,
        };
    },
    async created() {
        const { userId, leagueId } = this.$route.params;
        this.isNew = !!leagueId;
        if (this.isNew) {
            this.league = (await axios.get(`/api/register-get-league/${leagueId}`)).data;
            this.user = { name: '', guesses: {}, avatarId: null };
        }
        else {
            this.league = (await axios.get(`/api/get-league-for-user/${userId}`)).data;
            this.user = this.league.users.filter(u => u._id === userId)[0];
        }
        this.ready = true;
    },
    computed: {
        error() {
            const errors = [];
            if (!this.user.name.trim()) {
                errors.push('Please enter your name.');
            }
            if (!this.user.avatarId) {
                errors.push('Please choose an avatar.');
            }
            for (const question of this.league.questions) {
                const answerId = this.user.guesses[question._id];
                if (!answerId) {
                    const questionNumber = this.league.questions.indexOf(question) + 1;
                    errors.push(`Question ${questionNumber} needs an answer (${question.name})`);
                }
            }
            return errors[0];
        },
        editUrl() {
            return `https://props.allstarapps.com/user/${this.user._id}/${this.user.name.toLowerCase().replace(/[^a-z0-9]/gi, '')}`;
        }
    },
    methods: {
        clickAutoSelect() {
            for (const question of this.league.questions) {
                const answerId = this.user.guesses[question._id];
                if (!answerId) {
                    let answers = question.answers.filter(a => a.points);
                    let minPoints = _.minBy(answers, (a) => a.points).points;
                    let minAnswers = answers.filter(a => a.points === minPoints);
                    Vue.set(this.user.guesses, question._id, _.sample(minAnswers)._id);
                }
            }
            window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: "smooth" });
        },
        answerAll() {
            for (const question of this.league.questions) {
                const answerId = this.user.guesses[question._id];
                if (!answerId) {
                    let answers = question.answers.filter(a => a.points);
                    Vue.set(this.user.guesses, question._id, _.sample(answers)._id);
                }
            }
        },
        async save() {
            try {
                const response = await axios.post('/api/update-user', { user: this.user, leagueId: this.league._id });
                this.user = response.data.user;
                this.finished = true;
                window.scrollTo(0, 0);
            }
            catch (e) {
                const msg = (e.response && e.response.data) || e;
                alert(msg);
            }
        },
    },
    components: {
        question_component: require('./question.vue').default,
        avatar: require('./avatar.vue').default,
    },
};
